import React, { useCallback, useState } from "react";
import { callGradientJStreamAPI } from "services/gpt/callGradientJStreamAPI";

const useStreamSEOOptimizedBio = () => {
  const [bio, setBio] = useState<string>("");
  const [gptBusy, setGptBusy] = useState(false);

  const generateSEOOptimizedBioFromUserData = useCallback(
    async ({
      candidateData,
      setError,
    }: {
      candidateData: string;
      setError: (
        value: React.SetStateAction<string | Error | undefined>,
      ) => void;
    }) => {
      if (gptBusy) {
        return;
      }

      setGptBusy(true);
      setBio("");

      const onStreamMessage = (message: string) => {
        setBio((prevBio) => prevBio + message);
      };

      try {
        const { responseText } = await callGradientJStreamAPI({
          modelUUID: "44003316-64b1-4ad5-8f70-4a381bdc23c9",
          onStreamMessage,
          params: {
            candidate_data: candidateData,
          },
        });

        setBio(responseText);
        setGptBusy(false);
      } catch (error) {
        setError(error as Error);
        setGptBusy(false);
      }
    },
    [gptBusy],
  );

  return {
    bio,
    gptBusy,
    generateSEOOptimizedBioFromUserData,
    setBio,
  };
};

export default useStreamSEOOptimizedBio;
